import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader, Dialog } from 'components';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import fetch from 'features/common/fetch';
import taskDetail from 'features/views/taskDetail';
import { dialogs } from 'features/views/taskDetail/constants';

import TaskAttachment from './TaskAttachment';

const { urls } = fetch.constants;

export const Attachments = ({ taskId, onReload }) => {
	const attachments = useSelector(taskDetail.selectors.getAttachments);

	return (
		<ComponentLoader onReload={onReload} fetchStorePath={urls.taskAttachment}>
			<Paper sx={{ p: 3, borderRadius: 2 }}>
				<Stack spacing={2}>
					<SectionHeader text={getLabelMessage('detail:attachmentsSubheader')} />
					<Dialog mui name={dialogs.errorAttachmentNotFound}>
						{getLabelMessage('detail:errorAttachmentNotFound')}
					</Dialog>
					<Stack>
						{attachments && attachments.map((item) => <TaskAttachment item={item} taskId={taskId} />)}
					</Stack>
				</Stack>
			</Paper>
		</ComponentLoader>
	);
};

Attachments.propTypes = {
	onReload: PropTypes.func,
	taskId: PropTypes.string,
};

export default Attachments;
